export default "__VITE_ASSET__628d3f62__"